import { AxiosResponse } from 'axios';
import environment from '@environment';
import { CacheAreaKey } from 'core/config/cache-config';
import { SwitchCurrencyDTO } from 'core/models/general/switch-currency';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { StorageHelper } from 'core/services/storage';

export class CurrencyService {
  private static apiBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}/${environment.MAH_API_CURRENCY}/${environment.MAH_API_VERSION}`);
  private static tempBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}`);

  static getExchangeRate(country: string, toCurrency: string): Promise<SwitchCurrencyDTO> {
    const url = this.tempBuilder.createUrl('exchange-rate')
      .addRouteParam('get')
      .addQueryParam('country', country)
      .addQueryParam('toCurrency', toCurrency)
      .addQueryParam('clearCache', true)
      .build();

    const storedItems = (StorageHelper<SwitchCurrencyDTO>).GetInstance.getFromCache('req', url, CacheAreaKey.Currency);
    if (storedItems) {
      return Promise.resolve(storedItems as SwitchCurrencyDTO);
    }

    return HttpClient.GetInstance.get<SwitchCurrencyDTO>(url)
      .then(
        (res: AxiosResponse<SwitchCurrencyDTO>) => (
          (StorageHelper<{ [key: string]: SwitchCurrencyDTO }[]>).GetInstance
            .setCacheAndReturn(
              'req',
              CacheAreaKey.Currency,
              res?.data,
              url
            ) as SwitchCurrencyDTO
        )
      );
  }

  // NOTE: this is the uni API service- not currently used due to the auth layer in front of it, though this is the one we should be using.
  static getAuthenticatedExchangeRate(country: string, customerNumber: string, toCurrency: string): Promise<SwitchCurrencyDTO> {
    const url = this.apiBuilder.createUrl('Currency')
      .addQueryParam('country', country)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('toCurrency', toCurrency)
      .build();

    const storedItems = (StorageHelper<SwitchCurrencyDTO>).GetInstance.getFromCache('req', url, CacheAreaKey.Currency);
    if (storedItems) {
      return Promise.resolve(storedItems as SwitchCurrencyDTO);
    }

    return HttpClient.GetInstance.get<SwitchCurrencyDTO>(url)
      .then(
        (res: AxiosResponse<SwitchCurrencyDTO>) => (
          (StorageHelper<{ [key: string]: SwitchCurrencyDTO }[]>).GetInstance
            .setCacheAndReturn(
              'req',
              CacheAreaKey.Currency,
              res?.data,
              url
            ) as SwitchCurrencyDTO
        )
      );
  }
}